export const ROUTES = {
  AUTH: {
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    VERIFY_OTP: '/verify-otp',
    RESET_PASSWORD: '/reset-password',
  },
  DASHBOARD: '/dashboard',

  MEMBERS: '/members',
  PERMISSIONS: '/permissions',
  PLANS: '/plans',
  BLOGS: '/blogs',
  LANGUAGES: '/languages',
  TESTIMONIALS: '/testimonials',
  SUBSCRIPTIONS: '/subscriptions',
  BILLING: '/billing',
  TRANSACTIONS: '/transactions',
  APP_SETTINGS: {
    HOME: '/app-settings',
    WEB_PAGES: '/web-pages',
    PAYMENT_SETUP: '/payment-setup',
  },
  SUPPORT: {
    KNOWLEDGE_BASE: '/support/knowledge-base',
  },
  INQUIRIES: '/inquiries',
  FAQS: '/faqs',
  SOCIAL_MEDIA: {
    HOME: '/social-media/dashboard',
    CHANNELS: '/social-media/channels',
    CALENDAR: '/social-media/calendar',
    POST_QUEUE: '/social-media/post-queue',
    CREATE_POST: '/social-media/create-post',
    ACTIVITY: '/social-media/activity',
    SETTINGS: '/social-media/social-settings',
  },
  PROFILE: '/profile',
  MEDIA_LIBRARY: '/media-library',
  AI_PROVIDERS: '/ai-providers',
  AI_TEMPLATE_CATEGORIES: '/ai-template-categories',
  AI_TEMPLATES: '/ai-templates',
  PROMPT_LIBRARY: '/prompt-library',
  TEXT_TO_IMAGE: '/text-to-image',
  IMAGE_TO_IMAGE: '/image-to-image',
  TEXT_TO_VIDEO: '/text-to-video',
  IMAGE_TO_VIDEO: '/image-to-video',
  VIDEO_MOTION: '/video-motion',
  LANDING: '/',
  LANDING_MANAGEMENT: '/landing-page',
  EMAIL_TEMPLATES: '/email-templates',
  USAGE_LOGS: '/usage-logs',
  HOME: '/',
} as const
